import React, { useContext, useMemo } from 'react'
import { Carousel, type CarouselOptions, CarouselSlide, AutoScroll, Image } from '@hermes/web-components'
import { ProudlyText, Container, Line, TrustedByContainer } from './styles'
import { preloadImageLoader } from '../../../utils/imageLoaders'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import { AppDataContext } from 'providers/AppData'
import { TENANTS } from '../../../constants/global'

const CAROUSEL_OPTIONS = {
  type: 'loop',
  lazyLoad: 'sequential',
  perMove: 1,
  gap: '45px',
  drag: 'free',
  autoWidth: true,
  autoScroll: { speed: 0.5, pauseOnHover: true, pauseOnFocus: false },
  pagination: false,
  arrows: false
} as CarouselOptions

const defaultIcons = [
  { mockId: 1, name: 'Nuffiled', width: 125 },
  { mockId: 2, name: 'HCA', width: 125 },
  { mockId: 3, name: 'Optegra', width: 90 },
  { mockId: 4, name: 'Vitality', width: 81 },
  { mockId: 5, name: 'WPA', width: 55 },
  { mockId: 6, name: 'Ramsay', width: 46 },
  { mockId: 7, name: 'Cleavland', width: 232 }
]

const auIcons = [
  ...defaultIcons,
  {
    mockId: 8,
    name: 'Cabrini',
    width: 55
  },
  { mockId: 9, name: 'CompleteHealth', width: 82 },
  { mockId: 10, name: 'SkinHealth', width: 98 }
]

const uaeIcons = [
  ...defaultIcons,
  { mockId: 8, name: 'Clemenceua', width: 163 },
  { mockId: 9, name: 'EmirateHospital', width: 150 },
  { mockId: 10, name: 'PrimeCentre', width: 90 },
  { mockId: 11, name: 'SaudiGermanHospital', width: 130 },
  { mockId: 12, name: 'Sulaiman', width: 71}
]
const host = process.env.NEXT_PUBLIC_HOST || ''

const TrustSection = () => {
  const translate = useTranslateMessage()
  const { locale } = useContext(AppDataContext)

  const iconsArray = useMemo(() => {
    if (locale === TENANTS.EN_UAE || locale === TENANTS.AR_UAE) {
      return uaeIcons
    }

    if (locale === TENANTS.AU) {
      return auIcons
    }

    return defaultIcons
  }, [locale])

  return (
    <Container>
      <TrustedByContainer>
        <ProudlyText>{translate('homepage.trust.carousel.title')}</ProudlyText>
        <Line />
        <Carousel lazyLoad updateOnMove options={CAROUSEL_OPTIONS} extensions={{ AutoScroll }} sx={{ width: '100%' }}>
          {iconsArray?.map((item) => (
            <CarouselSlide key={item.mockId}>
              <div style={{ width: item.width }}>
                <Image
                  lazy
                  src={preloadImageLoader({
                    src: `/hermes-static/images/trustedCompanies/${item.name}.png`,
                    host
                  })}
                  width={item.width}
                  style={{
                    objectFit: 'contain'
                  }}
                  height={40}
                  alt={`Provider image ${item.name}`}
                />
              </div>
            </CarouselSlide>
          ))}
        </Carousel>
      </TrustedByContainer>
    </Container>
  )
}

export default TrustSection
